import { useState } from 'react';

import {
  Users,
  Award,
  Globe,
  Truck,
  Phone,
  Mail,
  MapPin,
  CheckCircle,
  Star,
  Building2,
  Handshake,
  Target,
  ArrowRight,
  X, 
  Menu
} from 'lucide-react';

function Parteneri() {
  const [hoveredPartner, setHoveredPartner] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationItems = [
    { name: 'Acasă', href: '/' },
    { name: 'Servicii', href: '/servicii' },
    { name: 'Parteneri', href: '/parteneri' },
    { name: 'Despre Noi', href: '/despre' },
    { name: 'Contact', href: '/contact' }
  ];

  // Partenerii companiei VGL Trans Express
  const partners = [
    {
      id: 1,
      name: "MedLife",
      logo: './Logo-MedLife.png',
      description: "Cel mai mare furnizor de servicii medicale private din România, partener de încredere de aproape trei decenii.",
      sector: "Servicii Medicale",
      colaborareDin: "2020",
      tipParteneriat: "Strategic"
    },
    {
      id: 2,
      name: "Gebrüder Weiss",
      logo: './Gebruder.png',
      description: "Cea mai veche companie de transport și logistică din Austria, în proprietatea familiilor fondatoare.",
      sector: "Transport & Logistică",
      colaborareDin: "2019",
      tipParteneriat: "Internațional"
    },
    {
      id: 3,
      name: "Clinica Sanovil",
      logo: './Sanovil.png',
      description: "Spital privat acreditat ANMCS înființat în 2007, în continuu proces de extindere a serviciilor medicale.",
      sector: "Servicii Medicale",
      colaborareDin: "2021",
      tipParteneriat: "Regional"
    },
    {
      id: 4,
      name: "Pall-Ex Group",
      logo: './PALL-EX.png',
      description: "Înființat în Marea Britanie în 1996, răspuns la nevoia clienților de reducere a stocurilor și creșterea flexibilității.",
      sector: "Logistică",
      colaborareDin: "2020",
      tipParteneriat: "Internațional"
    },
    {
      id: 5,
      name: "Logistic E Van Wijk",
      logo: './E-van-wijk.png',
      description: "Înființată la începutul anilor '90 în Cluj-Napoca, parteneriat româno-olandez, furnizor de servicii logistice integrate.",
      sector: "Transport & Logistică",
      colaborareDin: "2019",
      tipParteneriat: "Regional"
    },
    {
      id: 6,
      name: "Quehenberger",
      logo: './Quehenberger.png',
      description: "Companie holding în managementul strategic și operativ al furnizorilor de logistică orientați spre calitate.",
      sector: "Logistică",
      colaborareDin: "2021",
      tipParteneriat: "Strategic"
    }
  ];

  const stats = [
    { number: "6+", label: "Parteneri Strategici", icon: <Handshake className="w-6 h-6" /> },
    { number: "15+", label: "Ani de Colaborare", icon: <Award className="w-6 h-6" /> },
    { number: "3", label: "Țări Acoperite", icon: <Globe className="w-6 h-6" /> },
    { number: "100%", label: "Încredere Reciprocă", icon: <Star className="w-6 h-6" /> }
  ];

  const benefits = [
    {
      icon: <Globe className="w-8 h-8" />,
      title: "Acoperire Internațională",
      description: "Prin partenerii noștri, oferim servicii de transport în toată Europa și nu numai."
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: "Calitate Garantată",
      description: "Colaborăm doar cu companiile care respectă cele mai înalte standarde de calitate."
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: "Flotă Extinsă",
      description: "Accesul la o flotă combinată de vehicule pentru orice tip de transport."
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Soluții Personalizate",
      description: "Împreună cu partenerii, dezvoltăm soluții adaptate nevoilor specifice ale fiecărui client."
    }
  ];

  const getPartnerTypeColor = (tip) => {
    switch (tip) {
      case 'Strategic': return 'bg-red-100 text-red-800 border-red-200';
      case 'Internațional': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'Regional': return 'bg-green-100 text-green-800 border-green-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-orange-50">
      
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>


    


        
    

      {/* Main Content */}
      <div className="container mx-auto px-6 py-12">
        
        {/* Intro Section */}
        <div className="bg-white rounded-3xl shadow-xl p-8 mb-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Colaborări de <span className="text-orange-500">Încredere</span>
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Prin parteneriatele strategice cu cele mai importante companii de transport și logistică, 
              oferim servicii de cea mai înaltă calitate la nivel național și internațional.
            </p>
          </div>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 text-center group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="text-orange-500 mb-3 flex justify-center group-hover:scale-110 transition-transform duration-300">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Partners Grid */}
        <div className="mb-12">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">Partenerii Noștri Strategici</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {partners.map((partner) => (
              <div
                key={partner.id}
                className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-gray-100 cursor-pointer"
                onMouseEnter={() => setHoveredPartner(partner.id)}
                onMouseLeave={() => setHoveredPartner(null)}
              >
                {/* Partner Header */}
                <div className="p-6 border-b border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${getPartnerTypeColor(partner.tipParteneriat)}`}>
                      {partner.tipParteneriat}
                    </span>
                    <span className="text-sm text-gray-500">Din {partner.colaborareDin}</span>
                  </div>
                  
                  {/* Logo Container */}
                  <div className="w-full h-24 flex items-center justify-center bg-gray-50 rounded-2xl mb-4 group-hover:bg-white transition-colors duration-300">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-w-full max-h-16 object-contain filter group-hover:brightness-110 transition-all duration-300 transform group-hover:scale-105"
                      onError={(e) => {
                        e.target.src = `data:image/svg+xml;base64,${btoa(`
                          <svg width="200" height="80" xmlns="http://www.w3.org/2000/svg">
                            <rect width="100%" height="100%" fill="#f3f4f6"/>
                            <text x="50%" y="50%" font-family="Arial" font-size="16" fill="#f97316" text-anchor="middle" dominant-baseline="middle" font-weight="bold">
                              ${partner.name}
                            </text>
                          </svg>
                        `)}`;
                      }}
                    />
                  </div>
                  
                  <h4 className="text-xl font-bold text-gray-800 group-hover:text-orange-600 transition-colors duration-300">
                    {partner.name}
                  </h4>
                  <p className="text-sm text-orange-600 font-medium">{partner.sector}</p>
                </div>

                {/* Partner Description */}
                <div className="p-6">
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {partner.description}
                  </p>
                  
                  {hoveredPartner === partner.id && (
                    <div className="flex items-center text-orange-600 font-medium transition-all duration-300">
                      <span className="mr-2">Află mai multe</span>
                      <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                    </div>
                  )}
                </div>

                {/* Hover Effect Line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-orange-500 to-red-500 group-hover:w-full transition-all duration-500"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Section */}
        <div className="bg-white rounded-3xl shadow-xl p-8 mb-12">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">
            Avantajele Parteneriatelor Noastre
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center group">
                <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300">
                  {benefit.icon}
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">{benefit.title}</h4>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Partnership Approach */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-3xl shadow-xl p-8">
            <Building2 className="w-12 h-12 text-orange-500 mb-6" />
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Cum Selectăm Partenerii</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Experiență dovedită în domeniul transporturilor</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Standarde înalte de calitate și siguranță</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Certificări și acreditări internaționale</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Valori comune și viziune pe termen lung</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Capacitate de adaptare la nevoile clienților</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-3xl shadow-xl p-8 text-white">
            <Users className="w-12 h-12 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Deveniți Partenerul Nostru</h3>
            <p className="text-lg leading-relaxed mb-6">
              Suntem întotdeauna interesați să dezvoltăm noi colaborări cu companii serioase 
              din domeniul transporturilor și logisticii.
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-3" />
                <span>+40745 586 183</span>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-3" />
                <span>office@vgltransexpress.com</span>
              </div>
            </div>
          </div>
        </div>

       
        </div>
      </div>

      
    
  );
}

export default Parteneri;